type TermsDisclaimerProps = {
  termsUrl: string;
  privacyUrl: string;
};

export const TermsDisclaimer = ({ termsUrl, privacyUrl }: TermsDisclaimerProps) => (
  <p className="mt-[20px] text-[12px] text-lavender-50 font-inter leading-[16px]">
    By continuing, you agree to our{" "}
    <a className="text-accent-blue-400 underline font-medium" href={termsUrl} target="_blank" rel="noopener noreferrer">
      Terms of Service
    </a>{" "}
    and acknowledge our{" "}
    <a className="text-accent-blue-400 underline font-medium" href={privacyUrl} target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    .
  </p>
);
